'use strict';

var request = require('./request'),
    Track = require('./track'),
    prepareUrl = require('./prepareUrl');


function List ( config ) {
    var prop;

    config = config || {};

    for ( prop in config ) {
        this[prop] = config[prop];
    }

    this.requestLinks = {};
}


List.prototype = {};
List.prototype.constructor = List;


/**
 * Get tracks list in playlist.
 *
 * @param {Object} config - request
 * @param {Function} callback - result handler
 */
List.prototype.getTracks = function ( config, callback ) {
    request(
        prepareUrl('audio-playlists/' + this.id + '/audio-tracks', config),
        {
            method: 'GET',
            onload: function ( error, response ) {
                var data = [],
                    index;

                if ( !error ) {
                    for ( index = 0; index < response.data.length; index++ ) {
                        data[index] = new Track(response.data[index]);
                    }
                }
                callback(error, data, error ? 0 : response.paging.total);
            },
            onerror: callback
        },
        'getTracks',
        this.requestLinks
    );
};


/**
 * Edit playlist.
 *
 * @param {string} name - new name for list
 * @param {Function} callback - result handler
 */
List.prototype.edit = function ( name, callback ) {
    request(
        'audio-playlists/' + this.id,
        {
            method: 'PUT',
            body: JSON.stringify({name: name}),
            onload: function ( error, response ) {
                if ( callback ) {
                    callback(error, response.data);
                }
            },
            onerror: callback
        }
    );
};


/**
 * Get link to play.
 *
 * @param {Function} callback - result handler
 */
List.prototype.remove = function ( callback ) {
    request(
        'audio-playlists/' + this.id,
        {
            method: 'DELETE',
            onload: function ( error, response ) {
                if ( callback ) {
                    callback(error, response.data);
                }
            },
            onerror: callback
        }
    );
};


/**
 * Add track to playlist.
 *
 * @param {number} track - track id
 * @param {Function} callback - result handler
 */
List.prototype.addTrack = function ( track, callback ) {
    request(
        'audio-playlists/' + this.id + '/audio-tracks',
        {
            method: 'POST',
            body: JSON.stringify({id: track}),
            onload: function ( error, response ) {
                if ( callback ) {
                    callback(error, response.data);
                }
            },
            onerror: callback
        }
    );
};


/**
 * Add album to playlist.
 *
 * @param {number} album - album id
 * @param {Function} callback - result handler
 */
List.prototype.addAlbum = function ( album, callback ) {
    request(
        'audio-playlists/' + this.id + '/audio-albums',
        {
            method: 'POST',
            body: JSON.stringify({id: album}),
            onload: function ( error, response ) {
                if ( callback ) {
                    callback(error, response.data);
                }
            },
            onerror: callback
        }
    );
};


/**
 * Remove track from playlist.
 *
 * @param {number} track - track id
 * @param {Function} callback - result handler
 */
List.prototype.removeTrack = function ( track, callback ) {
    request(
        'audio-playlists/' + this.id + '/audio-tracks/' + track,
        {
            method: 'DELETE',
            onload: function ( error, response ) {
                if ( callback ) {
                    callback(error, response.data);
                }
            },
            onerror: callback
        }
    );
};


module.exports = List;
